import React from 'react';
import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {useParams} from 'react-router-dom';
import EventComponent from './EventComponent';
import EventPageLoader from './EventPageLoader';
import {EventContextProvider, EventType} from 'providers/EventProvider';
import {SplitContextProvider} from 'providers/SplitProvider';

const gqlQuery = gql`
  query GetSubEvent($slug: String!, $sub: String!) {
    event: getLiveEvent(slug: $slug, sub: $sub) {
      slug
      sub
      name
      startDate
      endDate
      publicDate
      location {
        lat
        lng
      }
      zoom
      status
      markerType
      competitors {
        id
        color
        name
        deviceName
        track {
          time
          lat
          lng
        }
        siData {
          siCard
          start
          finish
          controls {
            code
            time
          }
        }
        shortName
        startTime
      }
      maps {
        id
        name
        topLeft {
          lat
          lng
        }
        topRight {
          lat
          lng
        }
        bottomLeft {
          lat
          lng
        }
        height
        width
        url
        show
      }
      routes {
        id
        name
        color
        track {
          lat
          lng
        }
      }
      controlsAnalytic {
        id
        name
        type
        siCode
        position {
          lat
          lng
        }
      }
      subEvents {
        name
        sub
      }
    }
  }
`;

const EventPage: React.FC = () => {
  const {slug, sub} = useParams();
  const {loading, data, error} = useQuery<{event: EventType}>(gqlQuery, {
    variables: {
      slug,
      sub
    }
  });

  React.useEffect(() => {
    if (data?.event?.name) {
      document.title = `LiveZone - ${data.event.name}`;
    }
  }, [data?.event?.name]);

  if (loading) return <EventPageLoader />;
  if (error || !data) {
    console.error(error);
    return null;
  }

  return (
    <EventContextProvider
      key={`${data.event.slug}-${data.event.sub}`}
      value={{
        event: data.event,
        options: {
          showAllPlayers: true,
          timeGradient: false,
          opacity: 1,
          weight: 1
        }
      }}
    >
      <SplitContextProvider>
        <EventComponent />
      </SplitContextProvider>
    </EventContextProvider>
  );
};

export default EventPage;
